import { Component } from 'react'

import * as h from 'h'

import styles from './styles.scss'

export default class Switch extends Component {
  render () {
    const { name, onChange, brand, active } = this.props

    return h.z({
      name: 'toggle filter',
      onClick: onChange,
      ...h.ca(styles.switch, styles[brand], { [styles.active]: active })
    },
      name,
      h.div(h.ca(styles.inside)))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/SwitchFilters/Switch.js